<template>
  <div>
    <div class="article-block d-column">
      <div class="article-list">
        <div class="module j-flex">
          <div v-if="currPrograma != ''" class="fs-xl module-title weight">
            {{ currPrograma }}
          </div>
          <div v-else class="fs-xl module-title weight zrr">
            {{ title }}
          </div>
        </div>
      </div>
      <div v-if="title == '部门概况'">
        <div v-for="item in resData" :key="item.id">
          <div class="second-title fs-lg font-0" v-if="title == '部门概况'">
            {{ item.title }}
          </div>
          <div class="second-content fs-sm font-0" v-html="item.content"></div>
        </div>
      </div>
      <div v-else>
        <div class="second-content fs-sm font-0" v-html="resData.content"></div>
      </div>
      <!-- <div v-else style="display: grid; grid-template-columns: 50% 50%">
        <div
          v-for="item in priceData"
          :key="item.id"
          style="margin-bottom: 16px"
        >
          <div class="second-title fs-lg font-0">
            {{ item.venueName }}
          </div>
          <table>
            <tr v-for="(list, index) in item.resList" :key="index">
              <td>{{ list.areaName }}</td>
              <td>
                <div class="d-flex" style="align-items: flex-end">
                  {{ list.price }}&nbsp;元
                  <div class="fs-xs">&nbsp;&nbsp;/&nbsp;小时</div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  getDepartment,
  getCmsList,
  getArticleDetail,
  addClicks,
} from '@/api/api'
// import { getVenuePrice } from '@/api/api-venue'
export default {
  props: ['asideTitle', 'title', 'currPrograma'],
  data() {
    return {
      resData: [{ content: '123' }],
      priceData: [],
    }
  },
  created() {
    this.getDepartmentContent()
  },
  watch: {
    title: {
      handler() {
        this.getDepartmentContent()
      },
    },
  },
  methods: {
    getDepartmentContent() {
      if (this.title == '部门概况') {
        getDepartment().then((res) => {
          this.resData = res.data.obj
        })
      } else if (this.title == '场馆介绍') {
        getCmsList('venueintro', 1, 8).then((res) => {
          if (res.data.statusCode == 1) {
            this.resData = res.data.obj.data
          }
        })
      } else if (this.title == '收费标准') {
        getCmsList('venuecharges', 1, 8).then((res) => {
          if (res.data.statusCode == 1) {
            // this.resData = res.data.obj.data
            getArticleDetail(res.data.obj.data[0].id).then((res2) => {
              if (res.data.statusCode == 1) {
                this.resData = res2.data.obj
                addClicks(res.data.obj.data[0].id).then((res2) => {
                  if (res.data.statusCode == 1) {
                    this.resData.clicks = res2.data.obj.clicks
                  }
                })
                // let date = new Date(res.data.obj.publishDate)
                // that.articleInfo.publishDate = formateDate(date, 'yyyy-MM-dd hh:mm')
              }
            })
          }
        })
        // getVenuePrice().then((res) => {
        //   if (res.data.statusCode == 1) {
        //     this.priceData = res.data.obj
        //   }
        // })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.article-block {
  width: 692px;
  min-height: 548px;
  background-color: $white;
  padding: 24px 64px;
}
.module {
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}

.module-title {
  font-weight: 600;
}
.second-title {
  font-weight: 600;
  margin-top: 14px;
  margin-bottom: 14px;
}

table,
table tr th,
table tr td {
  border: 1px solid #d1d1d1;
  padding: 8px 16px;
  width: 320px;
}
table {
  border-collapse: collapse;
  padding: 2px;
}
.td-1 {
  width: 88px;
  height: 36px;
  text-align: center;
  background-color: #e8e8e8;
}
.td-2 {
  width: 432px;
  height: 20px;
  padding: 8px 16px;
}
.second-content ::v-deep img {
  max-width: 776px !important;
  margin-left: -16px;
}
</style>
